import React from "react";
import { Card, Form, Row, Col, Input, Select, Button, message } from "antd";
const DependentSKUEditor = ({
  editingItem,
  setEditingItem,
  offerSKU,
  skuId,
  categoryOptions,
  productOptions,
  productVariationOptions,
  productPricingOptions,
  handleCategoryChange,
  handleProductChange,
  handleSaveItem,
  toNumber,
  fetchProductPricingSKUs,
}) => {
  return (
    <Card size="small" hidden={offerSKU.isBundleSKU && offerSKU.addNewOrSelect === 2}>
      <Form layout="vertical" hidden={skuId}>
        <Row gutter={16}>
          {offerSKU.isBundleSKU && (
            <Col span={8}>
              <Form.Item label="Marketing Dependent SKU">
                <Input
                  value={editingItem?.dependent_sku}
                  onChange={(e) =>
                    setEditingItem({
                      ...editingItem,
                      dependent_sku: e.target.value?.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Form.Item label="Product Category">
              <Select
                options={categoryOptions}
                value={categoryOptions.find((category) => category.value === editingItem?.category)}
                onChange={handleCategoryChange}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Product">
              <Select
                options={productOptions}
                value={productOptions.find((product) => product.value === editingItem?.product)}
                onChange={handleProductChange}
                disabled={!editingItem?.category}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Product Variation">
              <Select
                options={productVariationOptions}
                value={productVariationOptions.find(
                  (variation) => variation.value === editingItem?.variation
                )}
                onChange={async (selected) => {
                  const selectedOption = productVariationOptions.find(
                    (variation) => variation.value === selected
                  );
                  setEditingItem({
                    ...editingItem,
                    variation: selectedOption.value,
                    product_code: selectedOption.product_code,
                    variation_code: selectedOption.variation_code,
                    description: `${editingItem.qtyDetailed} ${selectedOption.label}`,
                    unit_description: `${editingItem.qtyDetailed} ${selectedOption.label}`,
                  });
                  await fetchProductPricingSKUs(selectedOption.value);
                }}
                disabled={!editingItem?.product}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Unit Description">
              <Input
                value={editingItem?.unit_description}
                onChange={(e) =>
                  setEditingItem({
                    ...editingItem,
                    unit_description: e.target.value,
                  })
                }
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Product Pricing">
              <Select
                options={productPricingOptions}
                value={productPricingOptions.find(
                  (pricing) => pricing.value === editingItem?.product_pricing
                )}
                onChange={(selected) => {
                  const originalPrice =
                    toNumber(selected.original_price) * toNumber(editingItem.qty);
                  const discount = toNumber(editingItem.discount);
                  const finalPrice = originalPrice - discount;
                  setEditingItem({
                    ...editingItem,
                    product_pricing: selected.value,
                    product_pricing_sku: selected.label,
                    originalPrice,
                    finalPrice,
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Price">
              <Input disabled value={editingItem?.originalPrice} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Quantity">
              <Input
                type="number"
                value={editingItem?.qty}
                onChange={(e) => {
                  const newQty = toNumber(e.target.value);
                  const selectedPricing = productPricingOptions.find(
                    (pricing) => pricing.value === editingItem.product_pricing
                  );
                  const originalPrice = selectedPricing
                    ? toNumber(selectedPricing.original_price) * newQty
                    : toNumber(editingItem.originalPrice);
                  const discount = toNumber(editingItem.discount);
                  const finalPrice = originalPrice - discount;
                  setEditingItem({
                    ...editingItem,
                    qty: newQty,
                    originalPrice,
                    finalPrice,
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Qty Detailed">
              <Input
                value={editingItem?.qtyDetailed}
                onChange={(e) =>
                  setEditingItem({
                    ...editingItem,
                    qtyDetailed: e.target.value,
                    description: `${e.target.value} ${
                      productVariationOptions.find(
                        (variation) => variation.value === editingItem.variation
                      )?.label
                    }`,
                  })
                }
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Description">
              <Input
                value={editingItem?.description}
                onChange={(e) =>
                  setEditingItem({
                    ...editingItem,
                    description: e.target.value,
                  })
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Discount">
              <Input
                type="number"
                value={editingItem?.discount}
                onChange={(e) => {
                  const discount = toNumber(e.target.value);
                  setEditingItem({
                    ...editingItem,
                    discount,
                    finalPrice: toNumber(editingItem.originalPrice) - discount,
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Price to Pay">
              <Input disabled value={editingItem?.finalPrice} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Optional">
              <Select
                options={[
                  { value: "Yes", label: "Yes" },
                  { value: "No", label: "No" },
                ]}
                value={editingItem?.optional}
                onChange={(selected) =>
                  setEditingItem({
                    ...editingItem,
                    optional: selected,
                  })
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Rule">
              <Input.TextArea
                value={editingItem?.rule}
                placeholder="Enter rules"
                onChange={(e) =>
                  setEditingItem({
                    ...editingItem,
                    rule: e.target.value,
                  })
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item>
              <Button
                type="primary"
                onClick={() => {
                  if (editingItem) {
                    handleSaveItem(editingItem);
                    message.success("Marketing SKU saved successfully");
                  }
                }}>
                Save
              </Button>
              <Button onClick={() => setEditingItem(null)} style={{ marginLeft: 8 }}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default DependentSKUEditor;
